/* Shared "already subscribed?" helper for every email signup (Find your bag quiz, newsletter, search reveal).
   Loaded on every page by snippets/pb-quiz.liquid, which also renders the logged-in customer's marketing consent
   (data-pb-cust-sub) and the welcome code (data-pb-sub-code, data-pb-sub-pct).
   API (window.PBSub):
     PBSub.is()            -> true when this device has signed up before (pb_sub flag in localStorage or cookie, or the
                              quiz's older pbq_unlocked flag) or the logged-in customer accepts marketing
     PBSub.mark(source)    -> call after any successful signup ('quiz', 'newsletter', 'search'); sets the flag and fires
                              the document event 'pb:subscribed' (detail.source)
     PBSub.subscribe(email, source, extraTags) -> Promise<{ok, existing}>; signs the email up through the signup service
                              (no captcha). Never rejects: {ok:false} on any failure, and the caller posts its normal form
     PBSub.warm()          -> preloads the signup check (also runs on focus of any email field)
     PBSub.code, PBSub.pct -> the quiz code and its percentage (unique 2 hour code once ensureCode() has run, ITSINTHEBAG until then)
     PBSub.on(fn)          -> fn(source) after each mark()
     PBSub.SRC             -> signup source tags, added to contact[tags] next to the existing tags:
                              popupQuiz 'src-popup-quiz', popupFind 'src-popup-find-bag', homeQuiz 'src-home-quiz',
                              homeFind 'src-home-find-bag', newsletterHome 'src-newsletter-home',
                              footerNewsletter 'src-footer-newsletter', searchBar 'src-search-bar'
     PBSub.ATTR            -> 'Source', the cart attribute that carries the same tag to the order
     PBSub.cartSource(tag) -> Promise; sets cart attribute Source = tag unless the cart already has a Source
     PBSub.pending(tag)    -> for links out of a result (Shop this bag, Build your bundle): keeps tag in sessionStorage
                              (pb_src_pending); the next successful add to cart on any page (fetch or XHR to /cart/add,
                              or a /cart/add form post) calls cartSource(tag) once and clears it */
(function () {
  if (window.PBSub) return;
  var D = document, K = 'pb_sub', PK = 'pb_src_pending', subs = [];
  var QK = 'pb_quiz_code', CODES = 'https://store-codes.pinbuds-team.workers.dev/quiz-code';
  function heldCode() { try { var q = JSON.parse(localStorage.getItem(QK) || 'null'); return q && q.c && q.e > Date.now() + 60000 ? q.c : ''; } catch (e) { return ''; } }
  function el() { return D.querySelector('[data-pb-sub]'); }
  function attr(n, d) { var e = el(); var v = e && e.getAttribute(n); return v == null || v === '' ? d : v; }
  function ls(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function cookie() { try { return /(?:^|;\s*)pb_sub=1(?:;|$)/.test(D.cookie); } catch (e) { return false; } }
  function customer() { return attr('data-pb-cust-sub', 'false') === 'true'; }

  /* Signup without the storefront captcha: the signup service writes the customer (subscribed, with the tags) and answers
     {ok, existing}. A quiet invisible Turnstile check runs first. Never rejects: any failure resolves {ok:false} and the
     caller posts its normal Shopify form instead. */
  var RELAY = 'https://pinbuds-signup.pinbuds-team.workers.dev/subscribe', TS_KEY = '0x4AAAAAAFRtz7SMHctKm2Oh',
    TS_JS = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit', tsP = null, tsBox = null, tsId = null;
  function tsLib() {
    if (window.turnstile) return Promise.resolve(window.turnstile);
    if (!tsP) tsP = new Promise(function (res, rej) {
      var s = D.createElement('script'); s.src = TS_JS; s.async = true; s.defer = true;
      s.onload = function () { window.turnstile ? res(window.turnstile) : rej(); };
      s.onerror = function () { tsP = null; rej(); };
      D.head.appendChild(s);
    });
    return tsP;
  }
  function warm() { tsLib().catch(function () {}); }
  function tsToken() {
    return tsLib().then(function (T) {
      return new Promise(function (res, rej) {
        var t = setTimeout(function () { rej(); }, 10000);
        function ok(tok) { clearTimeout(t); res(tok); }
        function no() { clearTimeout(t); rej(); }
        try {
          if (!tsBox) {
            tsBox = D.createElement('div'); tsBox.setAttribute('aria-hidden', 'true');
            tsBox.style.cssText = 'position:fixed;left:-9999px;top:0;width:1px;height:1px;overflow:hidden';
            D.body.appendChild(tsBox);
          }
          if (tsId != null) { try { T.remove(tsId); } catch (x) {} tsId = null; }
          tsId = T.render(tsBox, { sitekey: TS_KEY, execution: 'execute', appearance: 'interaction-only', callback: ok,
            'error-callback': no, 'expired-callback': no, 'timeout-callback': no });
          T.execute(tsBox);
        } catch (x) { no(); }
      });
    });
  }
  function subscribe(email, source, extraTags) {
    var tags = ['newsletter'].concat(extraTags || []); if (source) tags.push(source);
    var seen = {}; tags = tags.map(function (t) { return String(t || '').trim().toLowerCase(); }).filter(function (t) { if (!t || seen[t]) return false; seen[t] = 1; return true; });
    var fail = function (why) { return { ok: false, existing: false, error: why || 'failed' }; };
    if (!window.fetch || !window.Promise) return Promise.resolve(fail('old'));
    return tsToken().then(function (ts) {
      var ctl = window.AbortController ? new AbortController() : null, tm = setTimeout(function () { if (ctl) ctl.abort(); }, 12000);
      return fetch(RELAY, { method: 'POST', mode: 'cors', credentials: 'omit', headers: { 'Content-Type': 'application/json' }, signal: ctl ? ctl.signal : undefined,
        body: JSON.stringify({ email: String(email || '').trim(), source: source || '', tags: tags, website: '', ts: ts }) })
        .then(function (r) { clearTimeout(tm); return r.json().catch(function () { return {}; }).then(function (j) {
          return r.ok && j && j.ok === true ? { ok: true, existing: !!j.existing } : fail(j && j.error || ('http' + r.status));
        }); }, function () { clearTimeout(tm); return fail('network'); });
    }, function () { return fail('challenge'); });
  }
  /* load the check as soon as someone starts typing an email, so the signup itself is quick */
  D.addEventListener('focusin', function (e) { var t = e.target; if (t && t.type === 'email') warm(); }, true);

  window.PBSub = {
    code: heldCode() || attr('data-pb-sub-code', 'ITSINTHEBAG'),
    pct: +attr('data-pb-sub-pct', 5) || 5,
    hours: 2,
    /* M-F67E: the quiz code is unique and really ends in 2 hours (tools/store-codes-worker). ensureCode() -> Promise<code>;
       a stored code that is still good is reused; any failure keeps the shared code so nobody is ever blocked */
    ensureCode: function () {
      var S = window.PBSub, held = heldCode();
      if (held) { S.code = held; return Promise.resolve(held); }
      if (S._cp) return S._cp;
      S._cp = fetch(CODES, { method: 'POST', mode: 'cors' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (d) {
        S._cp = null;
        if (d && d.ok && d.code) {
          try { localStorage.setItem(QK, JSON.stringify({ c: d.code, e: Date.parse(d.endsAt) })); } catch (e) {}
          S.code = d.code;
          try { D.dispatchEvent(new CustomEvent('pb:code', { detail: { code: d.code } })); } catch (e) {}
        }
        return S.code;
      }, function () { S._cp = null; return S.code; });
      return S._cp;
    },
    is: function () { return ls(K) === '1' || ls('pbq_unlocked') === '1' || cookie() || customer(); },
    mark: function (source) {
      try { localStorage.setItem(K, '1'); localStorage.setItem(K + '_src', String(source || '')); } catch (e) {}
      try { D.cookie = 'pb_sub=1; path=/; max-age=63072000; samesite=lax'; } catch (e) {}
      subs.forEach(function (f) { try { f(source); } catch (e) {} });
      try { D.dispatchEvent(new CustomEvent('pb:subscribed', { detail: { source: source || '' } })); } catch (e) {}
    },
    on: function (fn) { if (typeof fn === 'function') subs.push(fn); },
    SRC: { popupQuiz: 'src-popup-quiz', popupFind: 'src-popup-find-bag', homeQuiz: 'src-home-quiz', homeFind: 'src-home-find-bag',
      newsletterHome: 'src-newsletter-home', footerNewsletter: 'src-footer-newsletter', searchBar: 'src-search-bar' },
    ATTR: 'Source',
    pending: function (tag) { try { if (tag) sessionStorage.setItem(PK, tag); } catch (e) {} },
    subscribe: subscribe,
    warm: warm,
    cartSource: function (tag) {
      if (!tag) return Promise.resolve(false);
      var root = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/$/, '');
      return fetch(root + '/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
        if (c && c.attributes && c.attributes.Source) return false;
        var a = {}; a.Source = tag;
        return fetch(root + '/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: a }) }).then(function () { return true; });
      }).catch(function () { return false; });
    }
  };

  /* a pending source rides along to the next successful add to cart, once */
  function take() { var t = null; try { t = sessionStorage.getItem(PK); if (t) sessionStorage.removeItem(PK); } catch (e) {} return t; }
  function hasPending() { try { return !!sessionStorage.getItem(PK); } catch (e) { return false; } }
  function isAdd(u) { return /\/cart\/add(\.js)?(\?|$)/.test(String(u || '')); }
  function added() { var t = take(); if (t) window.PBSub.cartSource(t); }
  if (window.fetch) {
    var f0 = window.fetch;
    window.fetch = function (input, init) {
      var p = f0.apply(this, arguments);
      try {
        var u = typeof input === 'string' ? input : (input && input.url) || '';
        if (isAdd(u) && hasPending()) p.then(function (r) { if (r && r.ok) added(); }, function () {});
      } catch (e) {}
      return p;
    };
  }
  if (window.XMLHttpRequest) {
    var o0 = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (m, u) {
      try { if (isAdd(u)) this.addEventListener('load', function () { if (this.status >= 200 && this.status < 300 && hasPending()) added(); }); } catch (e) {}
      return o0.apply(this, arguments);
    };
  }
  /* a plain form post to /cart/add leaves the page: note it, and the next page sets the attribute (cartSource checks for
     an existing Source first) */
  D.addEventListener('submit', function (e) {
    var f = e.target; if (!f || !isAdd(f.getAttribute && f.getAttribute('action')) || !hasPending()) return;
    try { sessionStorage.setItem(PK + '_post', '1'); } catch (x) {}
  }, true);
  try { if (sessionStorage.getItem(PK + '_post')) { sessionStorage.removeItem(PK + '_post'); if (hasPending()) added(); } } catch (e) {}
})();

/* Search insights: window.pbInsight({s, q, n, t}) records one request (source, text, result count, top match) through a
   beacon to the insights service; fire and forget, never blocks, duplicates within 8 s are dropped. No personal data
   beyond the typed words; the page path is sent without its query string. Also defined by assets/pb-bagfind-field.js.
   Here: every submitted search from the header search or the search page, in either mode. */
(function () {
  var INS = 'https://pinbuds-insights.pinbuds-team.workers.dev/q', CAP = 300;
  if (!window.pbInsight) window.pbInsight = function (o) {
    try {
      if (!o || !o.q || String(o.q).trim().length < 2) return;
      var b = { s: String(o.s || ''), q: String(o.q).trim().slice(0, CAP), p: location.pathname, n: o.n == null ? null : o.n, t: o.t || null };
      var seen = window.__pbIns || (window.__pbIns = {}), k = b.s + '|' + b.q.toLowerCase(), now = Date.now();
      if (seen[k] && now - seen[k] < 8000) return; seen[k] = now;
      var body = JSON.stringify(b);
      if (navigator.sendBeacon && navigator.sendBeacon(INS, new Blob([body], { type: 'text/plain' }))) return;
      if (window.fetch) fetch(INS, { method: 'POST', body: body, keepalive: true, mode: 'cors', credentials: 'omit', headers: { 'content-type': 'text/plain' } }).catch(function () {});
    } catch (e) {}
  };
  if (window.__pbInsSearch) return; window.__pbInsSearch = 1;
  document.addEventListener('submit', function (e) {
    var f = e.target; if (!f || !f.classList || !f.classList.contains('pbs-form')) return;
    var inp = f.querySelector('[name="q"]'); if (!inp) return;
    var q = String(inp.value || '').trim(); if (q.length < 2) return;
    var on = f.querySelector('.pbs-modes [data-pbs-mode][aria-pressed="true"]');
    var find = on && on.getAttribute('data-pbs-mode') === 'find';
    var rec = { s: find ? 'find' : (f.closest('#FormSearch') ? 'header' : 'page'), q: q };
    if (find && window.pbBagFind && window.pbBagFind.match) {
      window.pbBagFind.match(q).then(function (R) { rec.n = R.bags.length; rec.t = R.bags[0] && R.bags[0].b && R.bags[0].b.spec ? R.bags[0].b.spec.name : null; window.pbInsight(rec); }, function () { window.pbInsight(rec); });
    } else window.pbInsight(rec);
  }, true);
})();
